module.exports = new __parcel__URL__("whiteBg.bdc4e15a.jpg").toString();